<template>
    <div class="login">
        <navigation-bar Close/>
        <div class="main-content">
            <div class="logo"><Logo/></div>


            <el-form class="textBox" :model="form" ref="loginForm">
                <el-form-item>
                    <OpenEyes :value="form.name" :placeholder="'請輸入姓名'" :name="'name'"
                              :type="'chinese'" class="input-round" @setUserData="setUserData"/>
                </el-form-item>
                <el-form-item>
                    <OpenEyes :value="formdate" :placeholder="'生日輸入格式 20021010'" :name="'formdate'"
                              :type="'tel'" :maxlength="8" class="input-round" @setUserData="setUserData"/>
<!--                     <el-button slot="append" class="send-btn">重新發送</el-button>-->
                        <!-- <DatePicker class="datepicker" v-model="form.date" valueType="format" format="YYYY-MM-DD" placeholder="生日輸入格式 20020101"/> -->
                </el-form-item>

                <el-form-item>
                    <el-input placeholder="設定密碼 (6-12碼英數混合)" v-model="form.password" type="password"
                              show-password
                              autocomplete="off"
                              maxlength="12"/>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="再次確認密碼" v-model="form.rePassword" type="password"
                              show-password
                              autocomplete="off"
                              maxlength="12"/>
                </el-form-item>
                <el-form-item class="text-center checked privacy">
                    <el-checkbox v-model="form.checked">我已閱讀並同意
                        <span class="terms" @click="onClickPrivacy">使用者條款</span>
                    </el-checkbox>
                </el-form-item>
            </el-form>
            <div class="btn_box">
                <el-button round @click="submit" type="warning">註冊</el-button>
            </div>
        </div>

        <toast/>
        <div class="brand" v-if="!isWeb">
            <span>LIFE LINK 串門子品牌服務系統</span>
        </div>
        <comm-dialog ref="dialog" :value="commDialogShow" :outerContent="dialogTitle" :isCancel="false"
                     @result="dialogResult"
                     @close="(value) => { commDialogShow = value }"/>
        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>

        <!--網頁用-->
        <CommDialog :value="isShowDialogWeb"
                    class="isWeb isSmall"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <!--忘記密碼-->
            <Privacy isWeb class="web-content" v-if="isShowDialogWeb"/>
        </CommDialog>
    </div>
</template>

<script>
    // import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import {checkPassword} from "@/util/validators";
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import CommDialog from "@/components/CommDialog";
    import {notNull} from "@/util/common";
    import * as constDefine from '@/store/constDefine';
    import Logo from "@/components/Logo";
    import OpenEyes from "@/components/OpenEyes"
    import {saveCryptoUserInfo, saveCryptoUserPhone} from "@/util/cryptoLocalStorage";
    import Privacy from '@/views/auth/Privacy';
    export default {
        name: "Registered",
        components: {/*DatePicker,*/ Toast, CommDialog, Logo , OpenEyes , Privacy},
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        data() {
            return {
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                isLoading: false,
                // 因為找不到可以用watch控制第二層物件，所以先拉出來在watch洗回去
                formdate:'',
                fcmToken: '',
                form: {
                    name: '',
                    date: '',
                    password: '',
                    rePassword: '',
                    checked: false,
                    tel: this.isWeb ? this.dataTokenWeb.tel : this.$route.query.tel,
                    countryCode: this.isWeb ? (this.dataTokenWeb.countryCode || "+886") : (this.$route.query.countryCode || "+886"),
                    countryName: this.isWeb ? (this.dataTokenWeb.countryName || "TW") : (this.$route.query.countryName || "TW"),
                },
                error: {
                    phone: false,
                    verificationCode: false,
                    timer: 0
                },
                commDialogShow: false,
                dialogTitle: '',
                isShowDialogWeb: false,
                //Line用
                lineStatus: this.$route.query.lineStatus || "",
                //以上
            }
        },
        created() {

        },
        mounted() {
            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                this.form.name = this.dataObject.lineChannelUName || '';
            } catch (e) {
                this.dataObject = {}
            }
            this.restoreRegisterInfo();
        },
        destroyed() {

        },
        watch: {
            formdate: function () {
                if (this.formdate.length>8) {
                    this.formdate=this.formdate.substr(0,8);
                }
                this.formdate = this.formdate.replace(/((?![0-9]).)*$/,function(match){
                    return '';
                });
            }
        },
        methods: {

            /** 點擊隱私權 */
            onClickPrivacy: function () {
                this.saveRegisterInfo();

                if(!this.isWeb){
                    //APP、LINE綁定、商圈網頁版用
                    this.$router.push({name: 'Privacy'});
                }else {
                    //單店純網頁版用
                    this.isShowDialogWeb = true
                }
            },

            /** 暫存註冊資訊 */
            saveRegisterInfo: function () {
                this.$store.commit('saveRegPageSnapshot',
                    {
                        name:this.form.name,
                        birthday:this.formdate,
                        password:this.form.password
                    });
            },
            /** 回讀註冊資訊 */
            restoreRegisterInfo: function () {
                if ( this.$public.notNull(this.$store.state.regPageSnapshot)) {
                    if (this.$public.notNull(this.$store.state.regPageSnapshot.name)) {
                        this.form.name = this.$store.state.regPageSnapshot.name;
                    }
                    if (this.$public.notNull(this.$store.state.regPageSnapshot.birthday)) {
                        this.formdate = this.$store.state.regPageSnapshot.birthday;
                    }
                    if (this.$public.notNull(this.$store.state.regPageSnapshot.password)) {
                        this.form.password = this.$store.state.regPageSnapshot.password;
                    }
                }
            },


            /** dialog 回應 */
            dialogResult: function () {
                this.commDialogShow = false;
                if (this.dataObject.usedType === "webGetCoupon" && this.dataObject.id > 0) {
                    this.$router.replace({name: 'CouponPage', query: {'dataToken': this.dataToken}});
                } else if (this.dataObject.uri === "web-store-info" &&
                    (this.dataObject.usedType === "webIndex" || this.dataObject.usedType === "reward-point" ||
                        this.dataObject.usedType === "member" ||this.dataObject.usedType === "loyalty-card" ||
                        this.dataObject.usedType === "coupon" || this.dataObject.usedType === "oin-card")) {
                    let usedType = this.dataObject.usedType === "webIndex" ? "" : "/" + this.dataObject.usedType
                    let path = this.dataObject.uri + "/" + this.dataObject.storeCode + usedType;
                    this.$router.replace({path: path});
                } else {
                    if(!this.isWeb){
                        //APP、LINE綁定、商圈網頁版用
                        this.$router.go(-3);
                    }else {
                        //單店純網頁版用
                        this.$emit('result', true);
                        window.location.reload();
                    }
                }
            },

            /** 按下註冊 */
            submit: function () {
                // 把yyyyMMdd轉成後端可以直接吃同時也方便前端驗證的格式yyyy-MM-dd   (立即呼叫的函式表示式  IIFE)
                this.form.date = function (formdate) {
                    let count = 0;
                    let birthday = '';

                    //將生日轉成 yyyy-MM-dd 形式
                    formdate.split('').forEach(element => {
                        birthday = birthday+element;
                        if ([3,5].indexOf(count)>=0) {
                            birthday = birthday + '-';
                        }
                        count=count+1;
                    });
                    return birthday;
                }(this.formdate);

                if (this.form.name === null || this.form.name === "") {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '名稱不能為空');
                    return;
                } else if (this.form.date === null || this.form.date === '') {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '生日不能為空');
                    return;
                } else if( !this.dateExist(this.form.date) || !this.isNotTimeTraveler(this.form.date) ){
                    this.$store.commit(mutationTypes.SHOW_TOAST, '請確定生日無誤');
                    return;
                } else if (!checkPassword(this.form.password)) {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '密碼必須為6-12英文數字混合');
                    return;
                } else if (this.form.rePassword === '' || this.form.password === '' || this.form.rePassword !== this.form.password) {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '密碼與密碼確認不一致！');
                    return;
                } else if (!this.form.checked) {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '請先閱讀並同意使用條款');
                    return;
                }

                this.isLoading = true;
                this.register()
                    .then( this.login )
                    .then( this.getUserInfo )
                    .then( this.receiveNotification )
                    .then( (data) => {
                        this.isLoading = false;
                        this.dialogTitle = "註冊成功";
                        this.commDialogShow = true;
                    })
                    .catch( (error) => {
                        this.isLoading = false;
                        this.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 註冊 */
            register: function () {
                let self = this;

                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithEncrypt`Register${{
                        'countryCode': self.form.countryCode,
                        'countryName': self.form.countryName,
                        'phone': self.form.tel,
                        'password': self.form.password,
                        'name': self.form.name,
                        'birthday': self.form.date,
                        "isLine": self.dataObject.isLine || false,
                        "lineBasicId": self.dataObject.botId || '',
                        "lineUserId": self.dataObject.lineUserId || '',
                        "lineStatus": self.lineStatus
                    }}
                    ${json => {

                        if (json.status === true) {
                            //結束
                            resolve();
                        } else {
                            // this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                            reject('失敗, ' + json.message);
                        }
                    }}`;
                });
            },

            /** 登入 */
            login: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithEncrypt`SignIn${{
                        'countryCode': self.form.countryCode,
                        'countryName': self.form.countryName,
                        'phone': self.form.tel,
                        'password': self.form.password,
                        'userType': self.dataToken.userType || '',
                        "isLine": self.dataToken.isLine || false,
                        "lineUserId": self.dataToken.lineUserId || '',
                        "lineBasicId": self.dataToken.botId || '',
                    }}
                    ${json => {
                        if (json.status === true) {
                            self.$auth.setAdminToken(json.data.token);
                            // localStorage.setItem('phone', self.form.tel);
                            saveCryptoUserPhone(self.form.tel);
                            localStorage.setItem('token', json.data.token);
                            localStorage.setItem('nickName', json.data.nickName);
                            localStorage.setItem('userCode', json.data.userCode);
                            localStorage.setItem('lineToken', self.dataToken);

                            //結束
                            resolve();

                        } else {
                            reject('失敗, ' + json.message);
                        }
                    }}`;
                });
            },

            /** 取得個人資訊 */
            getUserInfo: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetUserInfoWithId${{}}
                    ${json => {

                        if (notNull(json.data)) {
                            saveCryptoUserInfo(json.data);
                            //結束
                            resolve(json.data);
                        } else {
                            reject('失敗, ' + json.message);
                        }
                    }}`;
                });
            },

            /** 推播處理 */
            receiveNotification: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    if (window.FirebasePlugin) {
                        let FirebasePlugin = window.FirebasePlugin;
                        //取得本機的 fcm token並更新
                        FirebasePlugin.getToken(function (token) {
                            window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, token);
                            self.fcmToken = token;
                            //如果已登入才更新 device token
                            if (self.$auth.isAdminLogin()) {
                                self.updateFcmToken();
                            }
                        });
                    }
                    resolve();
                });
            },

            /** 上傳新的 fcm token */
            updateFcmToken: function () {
                let self = this;

                this.$http.fetchWithAuth`UpdateDeviceToken${{
                    'token': self.fcmToken,
                    'os': self.$http.getOS(),
                }}`;
            },

            /** 驗證日期存在 */
            dateExist: function (dateStr) {
                let r = dateStr.split('-');
                let d = new Date( Number(r[0]), Number(r[1])-1, Number(r[2]));

                return (d.getFullYear()=== Number(r[0]) &&
                       (d.getMonth()+1)=== Number(r[1]) &&
                       (d.getDate()=== Number(r[2])) );
            },
            /** 出生日期不可為 未來時間或是距離現在超過150年 */
            isNotTimeTraveler: function (dateStr) {
                let r = dateStr.split('-');
                let d = new Date( Number(r[0]), Number(r[1])-1, Number(r[2]) );
                let nowDate = new Date();
                let dYear = d.getFullYear();
                let nowYear = nowDate.getFullYear();
                return (nowYear - dYear) > 0 && (nowYear - dYear) < 150;
            },
            /** 返回上頁 */
            goBack: function () {
                this.$router.go(-1)
            },
            setUserData(key,val){
                if (key==='name'){
                    this.form.name =val
                }
                else if(key==='formdate'){
                    this.formdate =val
                }
            },
            onCommDialogClose() {
                this.isShowDialogWeb = false;
            },
        },

    }
</script>
<style lang="less" scoped src="../../less/login.less"/>


